<script setup lang="ts">

import LoadSpinner from '@/application/components/LoadSpinner.vue';
import { useRouter } from 'vue-router';
import { onMounted } from 'vue';
import { MeinBedarf } from '@/application/router/types/types.ts';
import { useBedarfStore } from '@/bedarf/store/bedarfStore.ts';

const bedarfStore = useBedarfStore();
const router = useRouter();

onMounted(async () => {
  if (bedarfStore.verlauf.length === 0) {
    await bedarfStore.fetchBeratungsdaten(null);
  }

  if (bedarfStore.verlauf.length === 0) {
    await router.replace({ name: MeinBedarf.VERLAUF });
  } else {
    await router.replace({ path: useBedarfStore().verlauf[0]!.link });
  }
});
</script>

<template>
  <LoadSpinner class="my-auto" />
</template>
